const formatPercent = (val) => {
  if (typeof val !== 'number') {
    return '–%';
  }
  const percentage = (val * 100).toFixed(0);
  return `${percentage}%`;
};

export default formatPercent;
